import { Controller } from "@hotwired/stimulus";

// Share: on a touch device with a share sheet (phones, tablets) the trigger
// hands the page to that sheet; everywhere else it opens the menu beside it
// (dropdown_controller.js), whose rows copy the link or open a network's own
// share page. Desktop share sheets exist too, but they are sparse and unfamiliar
// there — a menu of the usual places reads better with a mouse.
//
// The trigger runs share#open before dropdown#toggle; when the sheet takes
// over, stopping the event keeps the menu shut. The copy row says it worked by
// swapping its idle content for a tick until the reader looks away.
//
//   <div data-controller="dropdown share" data-share-title-value="…" data-share-url-value="…">
//     <button hidden data-dropdown-target="trigger"
//             data-action="share#open dropdown#toggle">…</button>
//     <div data-dropdown-target="panel">
//       <button data-action="share#copy">
//         <span data-share-target="idle">…</span>
//         <span data-share-target="done" class="hidden">…</span>
//       </button>
//       …
//     </div>
//   </div>
export default class extends Controller {
  static targets = ["trigger", "idle", "done"];
  static values = {
    title: String,
    url: String,
    confirmDuration: { type: Number, default: 2000 },
  };

  connect() {
    this.triggerTarget.hidden = false;
  }

  disconnect() {
    clearTimeout(this.timeout);
  }

  open(event) {
    const data = { title: this.titleValue, url: this.urlValue };
    const sheet =
      navigator.share &&
      matchMedia("(pointer: coarse)").matches &&
      (!navigator.canShare || navigator.canShare(data));
    if (!sheet) return;

    event.stopImmediatePropagation();
    navigator.share(data).catch(() => {
      // Closed by the reader, or refused by the browser: nothing to undo.
    });
  }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.urlValue);
    } catch {
      return;
    }

    this.idleTarget.classList.add("hidden");
    this.doneTarget.classList.remove("hidden");

    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.doneTarget.classList.add("hidden");
      this.idleTarget.classList.remove("hidden");
    }, this.confirmDurationValue);
  }
}
